import { PractitionerMedicalServiceRemoveCommand } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { practitionerMedicalServiceTranslationKeys } from '../../../translations';
import { useRefetchMedicalServices } from '../../shared/queries/useRefetchMedicalServices';

type PractitionerMedicalServiceRemoveActionRenderer = (renderProps: {
   removePractitionerMedicalService: () => Promise<void>;
}) => JSX.Element;

type PractitionerMedicalServiceRemoveActionProps = {
   readonly practitionerMedicalServiceId: number;
   readonly children: PractitionerMedicalServiceRemoveActionRenderer;
};

export const PractitionerMedicalServiceRemoveAction = (
   props: PractitionerMedicalServiceRemoveActionProps
): JSX.Element => {
   const refetchMedicalServices = useRefetchMedicalServices();
   const { executeAsync } = useCqrsCommand<void, void>(
      () => {
         const command = new PractitionerMedicalServiceRemoveCommand();
         command.id = props.practitionerMedicalServiceId;
         return command;
      },
      {
         onSuccess: () => {
            refetchMedicalServices();
            dispatchSnackbarPositiveEvent(practitionerMedicalServiceTranslationKeys.remove.confirmation.snackbar);
         },
      }
   );

   return (
      <>
         {props.children({
            removePractitionerMedicalService: executeAsync,
         })}
      </>
   );
};
